import { render, staticRenderFns } from "./constructionRelactionTask.vue?vue&type=template&id=2be46562"
import script from "./constructionRelactionTask.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be46562')) {
      api.createRecord('2be46562', component.options)
    } else {
      api.reload('2be46562', component.options)
    }
    module.hot.accept("./constructionRelactionTask.vue?vue&type=template&id=2be46562", function () {
      api.rerender('2be46562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTask.vue"
export default component.exports